import { type ClientMonitoringEventTarget } from '@issuemanager/models';
import { useMonitoring } from '@issuemanager/apps/client/contexts';
import { useMemo } from 'react';

export function useMonitor(target: ClientMonitoringEventTarget) {
  const monitoring = useMonitoring();

  const { start, stop, error } = useMemo(
    () => ({
      start: () => monitoring.startTracking(target),
      stop: () => monitoring.stopTracking(target),
      error: () => monitoring.reportError(target),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [target],
  );

  return { start, stop, error };
}
